import Tracker from './Tracker';
import { labelEvents } from './FileBrowser';

const FormsTracker = new Tracker('Forms', {
	...labelEvents,
	CREATED: 'created'
});

export default FormsTracker;
